import { render, staticRenderFns } from "./private_limited_accordion.vue?vue&type=template&id=7f1336d4&"
import script from "./private_limited_accordion.vue?vue&type=script&lang=js&"
export * from "./private_limited_accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports